/** Быстрые шаблоны ответа «Чатов» — `/api/chats/templates`. Каждая ручка отвечает целым деревом. */
import { apiFetch } from "@/lib/api";

export type Template = { id: number; category_id: number; title: string; text: string; user: string };
/** `personal` — личная категория сотрудника (видит только он), иначе общая, компании. */
export type TemplateCategory = { id: number; name: string; personal: boolean; templates: Template[] };
export type TemplateTree = {
  categories: TemplateCategory[];
  /** Убранное: категории целиком (`templates` — сколько в них шаблонов) и отдельные шаблоны. */
  archive: {
    categories: { id: number; name: string; personal: boolean; at: string; templates: number }[];
    templates: (Template & { category: string; personal: boolean; at: string })[];
  };
};

const BASE = "/api/chats/templates";
const call = (path: string, method: string, body?: unknown) =>
  apiFetch<TemplateTree>(`${BASE}${path}`, body === undefined ? { method } : { method, body: JSON.stringify(body) });

export const loadTemplates = () => apiFetch<TemplateTree>(BASE);
export const seedTemplates = () => call("/seed", "POST");
export const createCategory = (name: string, personal: boolean) => call("/categories", "POST", { name, personal });
export const renameCategory = (id: number, name: string) => call(`/categories/${id}`, "PATCH", { name });
/** Порядок задаётся отдельно среди личных и среди общих. */
export const orderCategories = (ids: number[], personal: boolean) =>
  call("/categories/order", "POST", { ids, personal });
export const archiveCategory = (id: number) => call(`/categories/${id}`, "DELETE");
export const restoreCategory = (id: number) => call(`/categories/${id}/restore`, "POST");
export const createTemplate = (category_id: number, title: string, text: string) =>
  call("", "POST", { category_id, title, text });
export const editTemplate = (id: number, title: string, text: string) => call(`/${id}`, "PATCH", { title, text });
/** Шаблоны категории в этом порядке; шаблон другой категории в списке переезжает в эту. */
export const orderTemplates = (category_id: number, ids: number[]) => call("/order", "POST", { category_id, ids });
export const archiveTemplate = (id: number) => call(`/${id}`, "DELETE");
export const restoreTemplate = (id: number) => call(`/${id}/restore`, "POST");

const plain = (s: string) => s.toLowerCase().replaceAll("ё", "е");

/** Шаблоны под запрос: каждое слово запроса есть в названии, тексте или названии категории. */
export function findTemplates(categories: TemplateCategory[], q: string): TemplateCategory[] {
  const words = plain(q).split(/\s+/).filter(Boolean);
  if (words.length === 0) return categories.filter((c) => c.templates.length > 0);
  return categories
    .map((c) => ({
      ...c,
      templates: c.templates.filter((t) => {
        const hay = plain(`${c.name} ${t.title} ${t.text}`);
        return words.every((w) => hay.includes(w));
      }),
    }))
    .filter((c) => c.templates.length > 0);
}
